// extracted by mini-css-extract-plugin
export var brandBox = "product-card-module--brand-box--exOcA";
export var buttonContent = "product-card-module--button-content--siqfR";
export var cardFooter = "product-card-module--card-footer--Vcc+u";
export var container = "product-card-module--container--Vm4YP";
export var desktopActions = "product-card-module--desktop-actions--oEvpr";
export var desktopBrand = "product-card-module--desktop-brand--gKwkq";
export var desktopCard = "product-card-module--desktop-card--3JGp+";
export var desktopCategory = "product-card-module--desktop-category--rF+Mo";
export var desktopImage = "product-card-module--desktop-image--LTm+D";
export var desktopImageWrapper = "product-card-module--desktop-image-wrapper--UnQEj";
export var desktopMeta = "product-card-module--desktop-meta--MpsHg";
export var desktopZoom = "product-card-module--desktop-zoom--eMHPd";
export var desktopZoomIcon = "product-card-module--desktop-zoom-icon--bAPcv";
export var img = "product-card-module--img--+os-M";
export var imgContainer = "product-card-module--img-container--kPG8O";
export var padlock = "product-card-module--padlock--hbU+I";
export var textFirst = "product-card-module--text-first--uszOA";
export var textSecond = "product-card-module--text-second--76wU5";